<template>
  <div class="mx-4 relative h-24">
    <canvas id="timeBarBG"
      class="w-full mt-2 items-center overflow-hidden absolute" style="width: 100%;"></canvas>
    <canvas id="timeBar"
      class="w-full mt-2 items-center overflow-hidden absolute" style="width: 100%;"></canvas>
  </div>
</template>

<script>
import {colors} from '../colors/colors.js';
  import SunCalc from 'suncalc';

  export default {
    name: 'TimeBar',
    props: {
      blocks: Object,
      timerEndTimestamp: Number,
      blockTick: Number,
      userLocation: String,
    },
    data() {
      return {
        colors,
        timeBarWidth: 0,
        sunriseTime: {},
        location: '',
        canvas: null,
        canvasBG: null,
        topStart: 10,
        height: 50,
      }
    },
    computed: {
      // get all the blocks of type Block
      blockList() {
        const blocksTime = Object.values(this.blocks).filter(block => block.type === 'Block' || block.type === 'BlockCounter');
        return blocksTime;
      },
      startTime() {
        // calculate the microseconds of today - 4 hours
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        return start.getTime() - 6 * 60 * 60 * 1000;
      },
      endTime() {
        // calculate the microseconds of today + 4 hours
        const now = new Date();
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        return end.getTime() + 6 * 60 * 60 * 1000;
      },
    },
    methods: {
      getUserLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.location = `${position.coords.latitude},${position.coords.longitude}`;
            this.sunriseTime = SunCalc.getTimes(new Date(), 50.0755, 14.4378);
            this.drawSunriseSunset();
          }, (error) => {
            console.error("Error getting location: ", error);
          });
        } else {
          console.error("Geolocation is not supported by this browser.");
        }
      },
      calcPercentage(start, end) {
        // return {start: 0, end: 100}
        return {
          start: (start - this.startTime) / (this.endTime - this.startTime) * 100,
          end: (end - this.startTime) / (this.endTime - this.startTime) * 100,
        }
      },
      drawBar() {
        this.canvas = document.getElementById('timeBar');
        this.canvasBG = document.getElementById('timeBarBG');
        const ctx = this.canvas.getContext('2d');
        const ctxBG = this.canvasBG.getContext('2d');
        // set width of canvas to the width of the timeBar
        this.canvas.width = this.timeBarWidth;
        this.canvas.height = 80;

        this.canvasBG.width = this.timeBarWidth;
        this.canvasBG.height = 80;

        if (window.devicePixelRatio > 1) {
          var canvasWidth = this.canvas.width;
          var canvasHeight = this.canvas.height;

          this.canvas.width = canvasWidth * window.devicePixelRatio;
          this.canvas.height = canvasHeight * window.devicePixelRatio;
          this.canvas.style.width = canvasWidth + "px";
          this.canvas.style.height = canvasHeight + "px";

          this.canvasBG.width = canvasWidth * window.devicePixelRatio;
          this.canvasBG.height = canvasHeight * window.devicePixelRatio;
          this.canvasBG.style.width = canvasWidth + "px";
          this.canvasBG.style.height = canvasHeight + "px";

          ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
          ctxBG.scale(window.devicePixelRatio, window.devicePixelRatio);
        }

        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.drawBorder();
        this.drawRemainingTime();
        this.drawBlocks();
        this.drawHourLines();
        this.drawCurrentTime();
      },
      drawBorder() {
        const ctx = this.canvas.getContext('2d');
        ctx.beginPath();
        ctx.moveTo(12, this.topStart);
        ctx.arcTo(this.timeBarWidth - 2, this.topStart, this.timeBarWidth - 2, this.topStart + 10, 10);
        ctx.arcTo(this.timeBarWidth - 2, this.topStart + this.height - 12, this.timeBarWidth - 12, this.topStart + this.height - 12, 10);
        ctx.arcTo(2, this.topStart + this.height - 12, 2, this.topStart + this.height - 22, 10);
        ctx.arcTo(2, this.topStart, 12, this.topStart, 10);
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 4;

        // apply this shadow to the canvas
        // box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 8;
        ctx.shadowBlur = 25;

        ctx.fillStyle = '#ffffff';
        //ctx.fill();
        ctx.stroke();

        ctx.shadowColor = 'transparent';
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 0;

        // create inset shadow
        ctx.beginPath();
        ctx.moveTo(12, this.topStart + 2);
        ctx.arcTo(this.timeBarWidth - 2, this.topStart + 2, this.timeBarWidth - 2, this.topStart + 10, 10);
        ctx.arcTo(this.timeBarWidth - 2, this.topStart + this.height - 12, this.timeBarWidth - 12, this.topStart + this.height - 12, 10);
        ctx.arcTo(2, this.topStart + this.height - 12, 2, this.topStart + this.height - 22, 10);
        ctx.arcTo(2, this.topStart + 2, 12, this.topStart + 2, 10);
        ctx.strokeStyle = '#ffffff';
        ctx.globalAlpha = 0.3;
        ctx.lineWidth = 5;
        ctx.stroke();
        ctx.globalAlpha = 1;


      },
      drawRemainingTime() {
        const ctx = this.canvas.getContext('2d');
        // plot rectangle timerEndTimestamp from now till the end of the timer
        const endA = new Date(this.timerEndTimestamp);
        const endB = this.timeBarWidth * (endA.getTime() - this.startTime) / (this.endTime - this.startTime);
        const nowA = new Date();
        const nowB = this.timeBarWidth * (nowA.getTime() - this.startTime) / (this.endTime - this.startTime);

        ctx.globalAlpha = 0.3;

        ctx.fillStyle = '#000000';
        ctx.fillRect(nowB, this.topStart + 7, endB - nowB, this.height - 24);

        ctx.globalAlpha = 1;
      },
      drawCurrentTime() {
        const ctx = this.canvas.getContext('2d');
        // plot current time with a single red line
        const now = new Date();
        const nowX = this.timeBarWidth * (now.getTime() - this.startTime) / (this.endTime - this.startTime);
        ctx.beginPath();
        ctx.moveTo(nowX, 0);
        ctx.lineTo(nowX, this.height + 10);
        ctx.strokeStyle = '#dc2626';
        ctx.lineWidth = 2;
        ctx.stroke();

        // Add a red dot at the top of the line
        ctx.beginPath();
        ctx.arc(nowX, 4, 4, 0, 2 * Math.PI, false);
        ctx.fillStyle = '#dc2626';
        ctx.fill();
      },
      drawHourLines() {
        const ctx = this.canvas.getContext('2d');
        // plot a line for each hour
        for (let i = 0; i < 36; i++) {
          const x = this.timeBarWidth / 36 * i;
          ctx.beginPath();
          ctx.moveTo(x, this.topStart + 2);
          ctx.lineTo(x, this.height - 4);
          // set the color of the line
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 1;

          // if it is 4th or 28th line use different colour
          if (i === 6 || i === 30) {
            ctx.strokeStyle = '#000000';
            ctx.lineWidth = 3;

            // draw a number of the day below the line
            ctx.font = '12px Arial';
            ctx.fillStyle = '#000000';
            ctx.textAlign = 'center';
            const day = new Date(this.startTime + i * 60 * 60 * 1000);
            // get the number of the day
            const dayNumber = day.getDate();
            ctx.fillText(dayNumber, x, this.height + 12);
          }

          ctx.stroke();
        }
      },
      drawBlocks() {
        const ctx = this.canvas.getContext('2d');
        if (typeof this.blockList === 'undefined' || this.blockList.length === 0) {
          return;
        }

        this.blockList.forEach(block => {
          block.elements.forEach(element => {

            if (element.type === 'track' && block.type === 'Block') {
              const start = element.start;
              let end = element.end;

              if (end === null || end === undefined) {
                end = new Date().getTime();
              }

              const percentage = this.calcPercentage(start, end);

              const startX = this.timeBarWidth * percentage.start / 100;
              const endX = this.timeBarWidth * percentage.end / 100;

              let colorIndex = this.colors.findIndex(item => item.value === block.color );

              // add shadow to the block
              ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
              ctx.shadowOffsetX = 4;
              ctx.shadowOffsetY = 4;
              ctx.shadowBlur = 25;

              // add opacity to the block
              ctx.globalAlpha = 0.8;
              ctx.fillStyle = '#' + this.colors[colorIndex].colors[500];
              ctx.fillRect(startX, this.topStart + 6, endX - startX, this.height - 24);
              ctx.globalAlpha = 1;
              ctx.shadowColor = 'transparent';

              // add stroke to the block
              ctx.strokeStyle = '#' + this.colors[colorIndex].colors[900];
              ctx.lineWidth = 4;
              
              const radius = 4;
              const x = startX;
              const y = this.topStart + 8;
              const width = endX - startX;
              const height = this.height - 26;
              
              ctx.beginPath();
              ctx.moveTo(x + radius, y);
              ctx.lineTo(x + width - radius, y);
              ctx.arcTo(x + width, y, x + width, y + radius, radius);
              ctx.lineTo(x + width, y + height - radius);
              ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
              ctx.lineTo(x + radius, y + height);
              ctx.arcTo(x, y + height, x, y + height - radius, radius);
              ctx.lineTo(x, y + radius);
              ctx.arcTo(x, y, x + radius, y, radius);
              ctx.stroke();

            } else if (block.type === 'BlockCounter') {
              // plot the icon from element.icon on the start
              const start = element.start;
              const percentage = this.calcPercentage(start, start + 1);

              const startX = this.timeBarWidth * percentage.start / 100;
              // let colorIndex = this.colors.findIndex(item => item.value === block.color );

              const icon = block.faceType;
              // load the svg icon from /icons/' + type + '.svg
              const img = new Image();
              img.src = '/icons/' + icon + '.svg';

              img.onload = () => {
                ctx.drawImage(img, startX, 4, 16, 16);
              }
            }
          });
        });
      },
      drawWaves(sunriseX, sunsetX) {

        // draw background to be dark blue
        const ctx = this.canvasBG.getContext('2d');
        ctx.globalAlpha = 0.5;
        ctx.fillStyle = '#1e3a8a';
        ctx.fillRect(4, 12, sunsetX, this.height - 16);

        ctx.fillStyle = '#bae6fd';
        ctx.fillRect(sunriseX, 12, sunsetX - sunriseX, this.height - 16);

        // create a radial gradient that starts in the center of the (sunsetX - sunriseX) / 2
        // and is yellow on the inside and orange on the outside
        const gradient3 = ctx.createRadialGradient(sunriseX + (sunsetX - sunriseX) / 2, this.height / 2, 0, sunriseX + (sunsetX - sunriseX) / 2, this.height / 2, (sunsetX - sunriseX) / 2);
        gradient3.addColorStop(0, '#fcd34d');
        gradient3.addColorStop(1, '#bae6fd');
        ctx.fillStyle = gradient3;
        ctx.fillRect(sunriseX, 12, sunsetX - sunriseX, this.height - 16);

        ctx.fillStyle = '#1e3a8a';
        ctx.fillRect(sunsetX + 4, 12, this.timeBarWidth - sunsetX - 8, this.height - 16);

        // add random white dots between 0 and sunriseX and sunsetX and timeBarWidth
        for (let i = 0; i < 30; i++) {
          const x = 6 + Math.random() * (sunriseX - 10);
          const y = 10 + Math.random() * (this.height - 26);
          ctx.beginPath();
          ctx.arc(x, y, 1, 0, 2 * Math.PI, false);
          ctx.fillStyle = '#ffffff';
          ctx.fill();
        }

        for (let i = 0; i < 30; i++) {
          const x = 6 + Math.random() * (this.timeBarWidth - sunsetX) + sunsetX;
          const y = 10 + Math.random() * (this.height - 16);
          ctx.beginPath();
          ctx.arc(x, y, 1, 0, 2 * Math.PI, false);
          ctx.fillStyle = '#ffffff';
          ctx.fill();
        }

        // take the this.timeBarWidth and separate it into three parts based on sunrise and sunset
        // draw a wavey pattern at the bottom of the timebar that will look like country horizon, should be filled with colour
        this.drawWave(20, sunriseX, '#bae6fd', 9, 14, 10);
        this.drawWave(sunriseX, sunsetX, '#d9f99d', 9, 12, 10);
        this.drawWave(sunsetX, this.timeBarWidth - 4, '#bae6fd', 9, 12, 10);

        this.drawWave(10, sunriseX, '#93c5fd', 0, 14, 10);
        this.drawWave(sunriseX, sunsetX, '#bef264', 0, 12, 10);
        this.drawWave(sunsetX, this.timeBarWidth - 4, '#93c5fd', 0, 10, 10);

        this.drawWave(4, sunriseX, '#60a5fa', 0, 14, 10);
        this.drawWave(sunriseX, sunsetX, '#15803d', 0, 12, 10);
        this.drawWave(sunsetX, this.timeBarWidth - 4, '#60a5fa', 0, 10, 10);

        // draw a horizontal gradient that starts from 0 #1e3a8a, until sunriseX, then 10 pixels afterwards #7dd3fc
        const gradient = ctx.createLinearGradient(sunriseX - 20, 12, sunriseX+20, 12);
        gradient.addColorStop(0, '#1e3a8a');
        gradient.addColorStop(1, 'transparent');
        ctx.fillStyle = gradient;
        ctx.fillRect(sunriseX, 12, 20, this.height - 16);

        const gradient2 = ctx.createLinearGradient(sunsetX - 20, 12, sunsetX + 20, 12);
        gradient2.addColorStop(0, 'transparent');
        gradient2.addColorStop(1, '#1e3a8a');
        ctx.fillStyle = gradient2;
        ctx.fillRect(sunsetX - 20, 12, 20, this.height - 16);

        ctx.globalAlpha = 1;

      },
      drawWave(start = 0, end = 200, color = '#94a3b8', minWaveHeight = 2, maxWaveHeight = 6, waveWidth = 10) {
          const ctx = this.canvasBG.getContext('2d');
          ctx.beginPath();
          ctx.moveTo(start, this.height - 4);
          let prevX = start;
          let prevY = this.height - 20;
      
          for (let i = start + waveWidth; i <= end; i += waveWidth) {
              const waveHeight = Math.random() * (maxWaveHeight - minWaveHeight) + minWaveHeight;
              const nextX = i;
              let nextY = this.height - 20 + Math.sin((i - start) / waveWidth) * waveHeight;
              if (nextY > 50) { nextY = 50; }
              const controlX = (prevX + nextX) / 2;
              const controlY = (prevY + nextY) / 2;
      
              ctx.quadraticCurveTo(controlX, controlY, nextX, nextY);
      
              prevX = nextX;
              prevY = nextY;
          }
      
          ctx.lineTo(end, this.height - 20);
          ctx.lineTo(end, this.height - 4);
          ctx.lineTo(start, this.height - 4);
      
          ctx.fillStyle = color;
          ctx.fill();
      },
      drawSunriseSunset() {
        // Draw sunrise single orange line if this.sunriseTime.sunrise is set
        if (this.sunriseTime.sunrise) {
          const ctx = this.canvasBG.getContext('2d');

          ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

          const nowSunrise = this.sunriseTime.sunrise;
          const nowSunriseX = this.timeBarWidth * (nowSunrise.getTime() - this.startTime) / (this.endTime - this.startTime);
          ctx.beginPath();
          ctx.arc(nowSunriseX, 4, 3, 0, 2 * Math.PI, false);
          ctx.fillStyle = 'orange';
          ctx.fill();

          // Draw sunset
          const nowSunset = this.sunriseTime.sunset;
          const nowSunsetX = this.timeBarWidth * (nowSunset.getTime() - this.startTime) / (this.endTime - this.startTime);
          ctx.beginPath();
          ctx.arc(nowSunsetX, this.height + 4, 3, 0, 2 * Math.PI, false);
          ctx.fillStyle = 'black';
          ctx.fill();

          this.drawWaves(nowSunriseX, nowSunsetX);
          this.drawRemainingTime();
          this.drawBlocks();
          this.drawHourLines();
          this.drawBorder();
          this.drawCurrentTime();
        }
      }
    },
    watch: {
      blockTick() {
        const ctx = this.canvas.getContext('2d');
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.drawBorder();
        this.drawRemainingTime();
        this.drawBlocks();
        this.drawHourLines();
        this.drawCurrentTime();
      }
    },
    mounted() {
      if (!this.location) {
        this.getUserLocation();
      }
      // get the width in pixels of the timeBar
      const timeBar = document.getElementById('timeBar');
      this.timeBarWidth = timeBar.offsetWidth;
      this.drawBar();
    }
  }
</script>